/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */
import {MutationTree} from 'vuex';
import {SettingStateInterface} from '@/store/modules/settings/types';
import {Vue} from 'vue-property-decorator';

/**
 * Application settings mutations.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

export const mutations: MutationTree<SettingStateInterface> = {
    /**
     * Set new media state.
     *
     * @param {SettingStateInterface} state
     * @param {string[]} media
     */
    updateMedia(state: SettingStateInterface, media: string[]): void {
        Vue.set(state, 'media', media);
    },

    /**
     * Set language.
     *
     * @param {SettingStateInterface} state
     * @param {string} language
     */
    updateLanguage(state: SettingStateInterface, language: string): void {
        Vue.set(state, 'language', language);
    },

    /**
     * Update consent state.
     *
     * @param {SettingStateInterface} state
     * @param {boolean} consent
     */
    updateConsent(state: SettingStateInterface, consent: boolean): void {
        Vue.set(state, 'consent', consent);
    },

};
